"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _errorModule = _interopRequireDefault(require("./error.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _Button = require("../../elements/button/Button");
var _navigationHelper = require("../../context/settings/utils/navigationHelper");
var ErrorComponent = function ErrorComponent(_ref) {
  var errorMessage = _ref.errorMessage;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _errorModule.default['error']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _errorModule.default['error__message']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _errorModule.default['error__description']
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _errorModule.default['error__primary-header']
  }, t('errors.error')), /*#__PURE__*/_react.default.createElement("p", {
    className: _errorModule.default['error__primary-text']
  }, errorMessage), /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    "data-testid": "return-to-login",
    onClick: _navigationHelper.returnToLogin,
    className: _errorModule.default['error__button']
  }, t('errors.returnToLogin')))));
};
exports.ErrorComponent = ErrorComponent;